import {useContext, useEffect } from "react";
import Joyride from "react-joyride";
import cafgu from "../../../../../assets/images/core/cafgu.svg"
import { ToolContext } from "../../../../context/ToolContext";
import { ExploreTourToolTip } from "../ExploreTourToolTip";
import { VM } from "../../../../VM";

export const OnboardingMobile = ({ pathname, end, start}) => {

    const {personalization_state, tool_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    const {__SESSION} = tool_state

    const role = __SESSION.data.uaccess[0].role_name
    const view = VM()

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, onboarding:true}))
    }
    
    useEffect(() => {
        start("home", "onboarding-mobile", startTour)
        //eslint-disable-next-line
    }, []);
    

    const stepsRegularUser = [
            {
                placement: "center",
                disableBeacon: true,
                target: "body",
                // title: <Typography>Welcome to Point of Sale!</Typography>
            },
            {
                content: "Home allows you to select branch and create order",
                placement: "right",
                target: "#onboarding-regular-user-home",
                title: "Home",

            },
            {
                content: "To save end of day report, you must go to reports feature",
                placement: "right",
                target: "#onboarding-regular-user-reports",
                path: '/setup/branch/list',
                title: "End of Day Report"
            },
            {
                content: "Tool Categories holds different tools that can help you grow",
                placement: "right",
                target: "#onboarding-regular-user-tool-categories",
                title: "Reports",
                path: '/reports/branch-product',
            },
                    {
                content: "This holds your notifications",
                placement: "right",
                target: "#onboarding-regular-user-notifications",
                title: "Notifications",
                path: "/tool-categories/subscribed"
            },
            {
                content: "Tap here to view POFSIS tools",
                placement: "right",
                target: "#onboarding-regular-user-mytools",
                title: "My Tools"
            },
        ]


    const CustomTooltip = ({ step, primaryProps, skipProps, backProps, tooltipProps, size, index}) => (
        <ExploreTourToolTip  featureName="home" p_name="onboarding-mobile" role={role} view={view} end={end} image={cafgu} step={step} primaryProps={primaryProps} skipProps={skipProps} backProps={backProps} tooltipProps={tooltipProps} size={size} index={index} setter={()=>{walkthrough.set((prev)=>({...prev, onboarding: false}))}}/>
    );  

    return (
        <Joyride
            continuous
            callback={({ status}) => {
                if (status === 'finished') {
                    end("home", "onboarding-mobile")
                    walkthrough.set((prev)=>({...prev, order: true}))
                    // startHere.set((prev)=>({...prev, modal: true}))
                }
            }}
            disableOverlayClose={true}
            run={walkthrough.data.onboarding && window.location.pathname === pathname}
            steps={stepsRegularUser}
            hideCloseButton
            scrollToFirstStep
            showSkipButton={false}
            showProgress
            tooltipComponent={CustomTooltip}
            // spotlightClicks={true}
        />
    );
}
